skrilla.directive('audBankWithdrawalDetails', function () {
    return {
        templateUrl: 'directives/withdrawalDetails/audBankWithdrawalDetails.html',
        scope: {
            withdrawal: "="
        },
        controller: function ($scope, searchService, modalService, currencyService, envService, validationService, withdrawalService) {
            $scope.bounce = withdrawalService.bounceWithdrawal;
            $scope.validate = {};
            $scope.domain = envService.get() === 'test' ? 'picklebettest' : 'picklebet';
            $scope.processWithdrawal = {
                amount: $scope.withdrawal.requestedAmount / currencyService.getCurrencyAmount($scope.withdrawal.currency),
                withdrawalId: $scope.withdrawal.id,
                externalType: $scope.withdrawal.externalType
            };
            $scope.blocked = withdrawalService.blockedByProfileTag($scope.withdrawal)

            $scope.decline = function(){
                modalService.confirm("Are you sure you'd like to decline this withdrawal?", function(){
                    $scope.loading = true;
                    searchService.put("withdrawals/" + $scope.withdrawal.id + "/decline", {reason: $scope.reason}, "Withdrawal successfully declined!").then(function(response){
                        $scope.withdrawal.status = "DECLINED";
                        delete $scope.withdrawal.abaTransactionId;
                        delete $scope.withdrawal.abaAmountToPay;
                    }, function(){
                        $scope.loading = false;
                    });
                });
            }

            $scope.process = function(){
                if(validateForm(true)) {
                    modalService.confirm("Are you sure you'd like to process this withdrawal?",function(){
                        if ($scope.blocked) {
                            alert('You can not approve the withdrawal of a punter with a compliance review or bet check required tag');
                            return;
                        }
                        const request = {...$scope.processWithdrawal, amount: currencyService.multiply($scope.processWithdrawal.amount, $scope.withdrawal.currency)}
                        $scope.loading = true;
                        searchService.put("withdrawals/" + $scope.withdrawal.id + "/process", request, "Withdrawal successfully processed!").then(function (response) {
                            $scope.withdrawal.paidAmount = currencyService.multiply($scope.processWithdrawal.amount, $scope.withdrawal.currency);
                            $scope.withdrawal.status = $scope.withdrawal.paidAmount === $scope.withdrawal.requestedAmount ? "PAID" : "PARTIALLY_PAID";;
                            $scope.loading = false;
                        }, function(){
                            $scope.processWithdrawal.amount = currencyService.divide($scope.processWithdrawal.amount, $scope.withdrawal.currency);
                            $scope.loading = false;
                        });
                    });
                }
            }

            $scope.addToAba = function(){
                if(validateForm(false)) {
                    modalService.confirm("Are you sure you'd like to add this withdrawal to the ABA file?",function(){
                        if ($scope.blocked) {
                            alert('You can not approve the withdrawal of a punter with a compliance review or bet check required tag');
                            return;
                        }
                        var amountToPay = $scope.withdrawal.requestedAmount;
                        $scope.loading = true;
                        searchService.put("withdrawals/" + $scope.withdrawal.id + "/addToABA", {amountToPay: amountToPay}, "Withdrawal successfully added to ABA File!").then(function (response) {
                            $scope.loading = false;
                            $scope.withdrawal.abaTransactionId = response.data;
                            $scope.withdrawal.abaAmountToPay = amountToPay;
                        }, function(){
                            $scope.processWithdrawal.amount = currencyService.divide($scope.processWithdrawal.amount, $scope.withdrawal.currency);
                            $scope.loading = false;
                        });
                    });
                }
            }

            $scope.removeFromAba = function(){
                    modalService.confirm("Are you sure you'd like to remove this withdrawal from the ABA file?",function(){
                        $scope.loading = true;
                        searchService.put("withdrawals/" + $scope.withdrawal.id + "/removeFromABA", {}, "Withdrawal successfully removed from ABA File!").then(function (response) {
                            $scope.loading = false;
                            $scope.withdrawal.abaTransactionId = null;
                            $scope.withdrawal.abaAmountToPay = null;
                        });
                    });
            }

            $scope.beginProcess = function(){
                modalService.confirm("Are you sure you'd like to lock this withdrawal?", function(){
                    if ($scope.blocked) {
                        alert('You can not approve the withdrawal of a punter with a compliance review or bet check required tag');
                        return;
                    }
                    searchService.put("withdrawals/" + $scope.withdrawal.id + "/beginProcess", null, "Withdrawal now ready to be processed.").then(function(response){
                       $scope.withdrawal.status = "PROCESSING";
                       delete $scope.withdrawal.abaTransactionId;
                       delete $scope.withdrawal.abaAmountToPay;
                    });
                });
            }

            $scope.stopProcess = function(){
                modalService.confirm("Are you sure you'd like to unlock this withdrawal?", function(){
                    searchService.put("withdrawals/" + $scope.withdrawal.id + "/stopProcess", null, "Withdrawal now unlocked.").then(function(response){
                        $scope.withdrawal.status = "PENDING";
                    });
                });
            }

            function validateForm(process){
                var withdrawal = $scope.processWithdrawal;
                var inputs = [
                    validationService.buildFieldValidationObj("amount", validationService.isNotEmpty(withdrawal.amount), "Please enter an amount to pay")
                ];
                if(process){
                    inputs.push(validationService.buildFieldValidationObj("bankTransferCode", validationService.isNotEmpty(withdrawal.bankTransferCode), "Please enter a bank transfer code"))
                }
                return validationService.validateForm(inputs, $scope.validate)
            }

        }
    };
});
